if (!customElements.get('international-grid')) {
  customElements.define(
    'international-grid',
    class InternationalGrid extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-country-card]'));
        if (!this.cards.length) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }

        this.observeCards();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      observeCards() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const card = entry.target;
              const delay = card.getAttribute('data-delay') || '0ms';
              card.style.transitionDelay = delay;
              card.classList.add('is-visible');
              this.observer.unobserve(card);
            });
          },
          {
            threshold: 0.18,
            rootMargin: '0px 0px -8% 0px',
          }
        );

        this.cards.forEach((card) => this.observer.observe(card));
      }
    }
  );
}
